import { e2eTestId } from "@e2e/test-ids";
import { TooltipButton } from "@ui/components/common/content-with-tooltip";
import styled from "@emotion/styled";
import { OnboardingTooltip } from "@ui/components/onboarding/onboarding-tooltip";
import { OnboardingProgramQuickstartStep } from "@domain/onboarding/onboarding";
import { HeaderEditorButtonProps } from "@ui/pages/program-builder/header/program-builder-header";
import { physioMeTabletBreakpoint } from "@ui/style";
import React from "react";

interface ButtonsContainerHeaderProps {
	primaryButton?: HeaderEditorButtonProps;
	secondaryButton?: HeaderEditorButtonProps;
	primaryQuickstartTooltipVisible?: boolean;
	onPrimaryQuickstartTooltipRequestClose?: () => void;
	primaryQuickstartTooltipStep?:
		| OnboardingProgramQuickstartStep.START_TEMPLATE_GUIDE_01
		| OnboardingProgramQuickstartStep.START_DRAFT_GUIDE_01;
}

export const ButtonsContainerHeader: React.FC<ButtonsContainerHeaderProps> = ({
	primaryButton,
	secondaryButton,
	primaryQuickstartTooltipVisible,
	onPrimaryQuickstartTooltipRequestClose,
	primaryQuickstartTooltipStep,
}: ButtonsContainerHeaderProps) => (
	<ButtonContainer data-test={e2eTestId.createTemplatePage.headerButtonContainer}>
		{secondaryButton && (
			<TooltipButton
				id="secondary-button-target"
				data-test={e2eTestId.createTemplatePage.builderSecondaryButton}
				tooltipContent={secondaryButton.tooltip}
				className="white-space-nowrap"
				disabled={secondaryButton.disabled}
				uiStyle="secondary"
				onClick={secondaryButton.onClick}
				iconPos="right"
				icon={secondaryButton.icon}
				loading={secondaryButton.loading}
			>
				{secondaryButton.label}
			</TooltipButton>
		)}
		{primaryButton && (
			<>
		{primaryQuickstartTooltipVisible ? (
					<OnboardingTooltip
						placement="bottom"
						visible
			onboardingStep={primaryQuickstartTooltipStep ?? OnboardingProgramQuickstartStep.START_TEMPLATE_GUIDE_01}
						onClose={e => { onPrimaryQuickstartTooltipRequestClose?.(); e.stopPropagation(); }}
						onClickOutside={onPrimaryQuickstartTooltipRequestClose}
					>
						<span>
							<TooltipButton
								id="primary-button-target"
								data-test={e2eTestId.createTemplatePage.builderPrimaryButton}
								tooltipContent={primaryButton.tooltip}
								className="white-space-nowrap"
								disabled={primaryButton.disabled}
								onClick={primaryButton.onClick}
								iconPos="right"
								icon={primaryButton.icon ?? "pi pi-calendar"}
								loading={primaryButton.loading}
							>
								{primaryButton.label}
							</TooltipButton>
						</span>
					</OnboardingTooltip>
				) : (
					<TooltipButton
						id="primary-button-target"
						data-test={e2eTestId.createTemplatePage.builderPrimaryButton}
						tooltipContent={primaryButton.tooltip}
						className="white-space-nowrap"
						disabled={primaryButton.disabled}
						onClick={primaryButton.onClick}
						iconPos="right"
						icon={primaryButton.icon ?? "pi pi-calendar"}
						loading={primaryButton.loading}
					>
						{primaryButton.label}
					</TooltipButton>
				)}
			</>
		)}
	</ButtonContainer>
);

const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	margin-left: 16px;
	margin-right: 12px;

	@media ${physioMeTabletBreakpoint} {
		margin: unset;
		flex: 1;
		display: grid;
		grid-auto-flow: column;
		grid-auto-columns: minmax(0, 1fr);
		padding: 16px;
	}
`;